<mat-card style="height: -webkit-fill-available">
  <mat-card-header>
    <mat-card-title><h1>Company Risk Map</h1></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <canvas baseChart width="500" height="250"
      [datasets]="lineChartData"
      [options]="lineChartOptions"
      [colors]="lineChartColors"
      [legend]="lineChartLegend"
      [chartType]="lineChartType"
      (chartHover)="chartHovered($event)"
      (chartClick)="chartClicked($event)"></canvas>
  </mat-card-content>
</mat-card>